import styled from 'styled-components';

export const SignUpWrap = styled.section``;
